// src/common/useThemeLogoUrl.js (or .ts)
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getThemeSelectedLogoAction } from "../redux/actions/themeAction";

export function useThemeLogoUrl() {
  const dispatch = useDispatch();
  const dynamicTheme = useSelector((state) => state?.theme?.theme);
  const [logoUrl, setLogoUrl] = useState(null); // null = "unknown yet"

  useEffect(() => {
    if (!dynamicTheme?.themeId) return;

    const themeId = String(dynamicTheme.themeId);
    const storageKey = `theme-logo-${themeId}`;

    let cached = null;

    // 1) Try cached logo first (no flicker on subsequent loads)
    if (typeof window !== "undefined") {
      cached = window.localStorage.getItem(storageKey);
      if (cached) {
        setLogoUrl(cached);
      }
    }

    // 2) Always refresh in background
    (async () => {
      try {
        const res = await dispatch(getThemeSelectedLogoAction(themeId));
        const url =
          res?.payload?.signedUrl ||
          res?.payload?.url ||
          res?.signedUrl ||
          res?.url ||
          "";

        const finalUrl = url || "/logo192.png"; // fallback, but after fetch

        setLogoUrl(finalUrl);

        if (typeof window !== "undefined" && url) {
          window.localStorage.setItem(storageKey, finalUrl);
        }
      } catch (err) {
        console.error("Error loading theme logo", err);
        // only fallback if we had no cache
        if (!cached) {
          setLogoUrl("/logo192.png");
        }
      }
    })();
  }, [dispatch, dynamicTheme?.themeId]);

  return logoUrl; // null at very first render, then real/cached URL
}
